import { getErrorMessage } from '@mairistem/finances-utils';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import { deleteBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';

class BordereauSupprimerAction extends BaseLiquidationAction<BordereauWithState, BordereauActionType> {
  constructor(options: BaseLiquidationOptions = null) {
    super(options);
    this.label = 'Supprimer';
    this.type = BordereauActionType.SUPPRIMER;
  }

  execute = (_bordereau: BordereauWithState): TreeviewActionResult<BordereauWithState> => ({
    type: ActionResultType.MODAL,
    extraProps: {
      isSuperUser: this.isSuperUser,
      deleteModal: {
        visible: true,
      },
    },
  });

  executeAction = (bordereau: BordereauWithState): TreeviewActionResult<BordereauWithState> => ({
    result: new Promise((resolve, reject) => {
      deleteBordereau(bordereau.identifiant as number).then(() => {
        resolve(bordereau);
      }).catch((e) => {
        reject(Error(getErrorMessage(e, 'Erreur lors de la suppression du bordereau')));
      });
    }),
    type: ActionResultType.DELETE,
  });
}

export default BordereauSupprimerAction;
